import React from 'react';
import cx from 'classnames';
import styles from './sharing-modal-button.module.scss';

const SharingModalButton = ({ children, onClick, clicked, disabled = false, ariaLabel }) => {
  return (
    <button
      className={cx(styles.button, [clicked && styles.clicked], [disabled && styles.disabled])}
      onClick={onClick}
      disabled={disabled}
      tabIndex={0}
      aria-label={ariaLabel}
    >
      <span
        className={styles.text}
        tabIndex={-1}
      >
        {children}
      </span>
    </button >
  );
};

export default SharingModalButton;
